cbp-grid:not([hidden]) {
    display: grid;
    max-width: 100%;
}